import { render, staticRenderFns } from "./TaxformW9.vue?vue&type=template&id=67443266&scoped=true"
import script from "./TaxformW9.vue?vue&type=script&lang=ts"
export * from "./TaxformW9.vue?vue&type=script&lang=ts"
import style0 from "./TaxformW9.vue?vue&type=style&index=0&id=67443266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67443266",
  null
  
)

export default component.exports